var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, observable, reaction, runInAction, configure } from "mobx";
import { TActState } from "../../../services/banner";
configure({ isolateGlobalState: true });
export class CountdownStore {
    constructor(state, timer, refresh) {
        this.state = TActState.OnGoing;
        this.countDown = 0;
        this.refreshModule = (refresh) => __awaiter(this, void 0, void 0, function* () {
            const result = yield refresh();
            if (result) {
                runInAction("refresh module", () => {
                    var _a, _b;
                    this.state = result.actState;
                    this.timer = result.timer.time;
                    this.countDown = parseInt(((_b = (_a = result.timer) === null || _a === void 0 ? void 0 : _a.time) === null || _b === void 0 ? void 0 : _b.left) || "0", 10);
                });
            }
        });
        this.state = state;
        this.timer = timer === null || timer === void 0 ? void 0 : timer.time;
        reaction(() => this.state, (state) => {
            var _a;
            clearInterval(this.intervalId);
            if (state === TActState.ComingSoon || state === TActState.OnGoing) {
                this.countDown = parseInt(((_a = timer === null || timer === void 0 ? void 0 : timer.time) === null || _a === void 0 ? void 0 : _a.left) || "0", 10);
                this.intervalId = setInterval(() => {
                    if (this.countDown <= 0) {
                        clearInterval(this.intervalId);
                        this.refreshModule(refresh);
                        return;
                    }
                    runInAction("tick", () => {
                        this.countDown = this.countDown - 1;
                    });
                }, 1000);
            }
        }, { fireImmediately: true });
    }
}
__decorate([
    observable
], CountdownStore.prototype, "state", void 0);
__decorate([
    observable
], CountdownStore.prototype, "timer", void 0);
__decorate([
    observable
], CountdownStore.prototype, "countDown", void 0);
__decorate([
    action
], CountdownStore.prototype, "refreshModule", void 0);
